export default __webpack_public_path__ + "assets/static/data/app.model.5888181db131bb3a9a7d85c1b3bfd5a6.json";